import { useEffect, useState } from 'react';

interface SlideUpInProps {
  children: React.ReactNode;
  className?: string;
  fadeOut?: boolean;
}

export function SlideUpIn({
  children,
  className = '',
  fadeOut = false,
}: SlideUpInProps) {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setEntered(true), 20);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={
        'transform transition-all duration-300 ' +
        (fadeOut
          ? 'translate-y-2 opacity-0'
          : entered
          ? 'translate-y-0 opacity-100'
          : 'translate-y-2 opacity-0') +
        (className ? ' ' + className : '')
      }
    >
      {children}
    </div>
  );
}
